/**
 * @generated SignedSource<<600ebea6a361f5f9c4d230929c02ebf9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type dateTime_nativeIssueTable_DateTimeCellInner$data = {
  readonly id: string;
  readonly lazyIsEditableInIssueView?: boolean | null | undefined;
  readonly type: string;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef">;
  readonly " $fragmentType": "dateTime_nativeIssueTable_DateTimeCellInner";
};
export type dateTime_nativeIssueTable_DateTimeCellInner$key = {
  readonly " $data"?: dateTime_nativeIssueTable_DateTimeCellInner$data;
  readonly " $fragmentSpreads": FragmentRefs<"dateTime_nativeIssueTable_DateTimeCellInner">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isInlineEditingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "dateTime_nativeIssueTable_DateTimeCellInner",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "condition": "isInlineEditingEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "lazyIsEditableInIssueView"
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "dateTime_issueFieldDateTimeInlineEditFull_DateTimeInlineEditViewWithIsEditable_fragmentRef"
    }
  ],
  "type": "JiraDateTimePickerField"
};

(node as any).hash = "c3baa0db8782241eaaea7db996be28e0";

export default node;
